import { FunctionComponent, ReactNode } from 'react';
import cn from 'classnames';
import './Badge.scss';

export enum BadgeTypes {
  PrintType = 'badge--print-type',
  MinAmount = 'badge--min-amount',
  Selected = 'badge--selected',
  Organic = 'badge--organic',
}

interface BadgeProps {
  type: BadgeTypes;
  className?: string;
  title?: string;
  children?: ReactNode;
}
export const Badge: FunctionComponent<BadgeProps> = ({ type, className, title, children }) => {
  return (
    <div className={cn('badge', type, className)} title={title}>
      {children && children}
    </div>
  );
};

interface BadgeWithTooltipProps extends BadgeProps {
  tooltip: string;
}
export const BadgeWithTooltip: FunctionComponent<BadgeWithTooltipProps> = ({
  tooltip,
  ...badgeProps
}) => {
  return (
    <div className="badge-container">
      <Badge {...badgeProps} />
      <div className="badge-tooltip">
        <div className="badge-tooltip__arrow" />
        <p>{tooltip}</p>
      </div>
    </div>
  );
};
